import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { BlockchainServices } from './BlockchainServices';
import { blockchainSeo } from './BlockchainSoftwareDevelopmentPage.seo';
import type { BlockchainSoftwareDevelopmentPageProps } from './BlockchainSoftwareDevelopmentPage.types';
import { BlockchainUseCases } from './BlockchainUseCases';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { OurWork } from './OurWork';
import { TechStack } from './TechStack';

export const BlockchainSoftwareDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: BlockchainSoftwareDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...blockchainSeo} />
      <Hero />
      <BlockchainServices />
      <TechStack />
      <BlockchainUseCases />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to your custom Blockchain Software!"
        color="cyan"
      />
    </Layout>
  );
};
